import React from 'react';
import { Button, View, Text } from '@instructure/ui';
import Card from '../../Common/Card';
import { getStore, useCheckinStore } from '../../../stores/StoreContext';
/**
 * PromptApproval is a component that displays a card indicating whether
 * the session items can be approved. If all items are approved, it shows
 * a message allowing the user to approve the session and proceed. If not,
 * it notifies the user to review the rejected items.
 *
 * @returns {JSX.Element} A Card component with approval status message and action.
 */

const PromptApproval = () => {
  const CheckinStore = getStore('checkinStore');
  const allowApproval = useCheckinStore((state) => state.allowApproval);
  return (
    <Card>
      <Card.Body>
        <>
          {allowApproval ? (
            <View as="div" margin="large">
              <Text as="div">
                All items have been reviewed and accepted. You can now approve
                this session to continue to their exam.
              </Text>
              <Button color="success" onClick={CheckinStore.approveSession}>
                Approve Session
              </Button>
            </View>
          ) : (
            <View as="div" margin="large">
              <Text as="div">
                One or more items have been rejected. Close this window to
                review the items.
              </Text>
            </View>
          )}
        </>
      </Card.Body>
    </Card>
  );
};

export default PromptApproval;
